/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import onSelectHandler from 'root/src/client/logic/app/handlers/onSelectHandler'
import isNil from 'ramda/src/isNil'

export default ({
	props: {
		Option, classes, onSelect, setListOpen, isMulti,
		value, input, option, isActive,
	},
}) => (isNil(Option)
	? (
		<li
			key={option.value}
			value={option.value}
			className={classes.ddListItem}
			onClick={onSelectHandler(option, onSelect, setListOpen, isMulti, value, input)}
		>
			{ option.label }
		</li>
	)
	: (
		<Option
			key={option.value}
			innerProps={{
				onClick: onSelectHandler(option, onSelect, setListOpen, isMulti, value, input),
			}}
			isActive={isActive}
		>
			{option}
		</Option>
	))
